<template>
  <div
    class="bx--row"
    :class="{
      'bx--row--condensed': condensed,
    }"
  >
    <slot />
  </div>
</template>

<script setup lang="ts">
// Props
interface Props {
  condensed?: boolean;
}

const { condensed = false } = defineProps<Props>();
</script>
